// @flow
import { css } from "styled-components"

export const center = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`



// WEBPACK FOOTER //
// ./src/componentsStyled/Shared/index.js